// extracted by mini-css-extract-plugin
export default {"mn-cascade":"index_mn-cascade__M6Klc","mn-cascade-display":"index_mn-cascade-display__+qYWd"};